import { z } from 'zod'
export const TableChatSchema = z.object({
  id: z.string().uuid(),
  title: z.string(),
  updated_at: z.string(),
  can_continue: z.boolean(),
})
export type TableChat = z.infer<typeof TableChatSchema>
